<template>
    <div class="guest-block">
        <Logo/>
        <a class="guest-link" :href="homeUrl + '/login'">Login</a>
        <a class="guest-link" :href="homeUrl + '/signup'">Signup</a>
        <a class="guest-link ml-auto" :href="homeUrl + '/help'"><i class="icon-question7"></i>Help</a>
    </div>
</template>

<script>
import Logo from "@/components/navbar/components/Logo";
import mixinNavbar from "@/mixins/navbar/mixin";

export default {
    name: 'GuestBlock',
    components: {
        Logo
    },
    mixins: [mixinNavbar]
}
</script>
